import React from "react";

const ReceipeDetail = (props) => {
  const handleInputChange = (e, index) => {
    props.listInputChange(e, index);
  };
  const stockValue =
    props.listInfo?.current_stock ??
    props.listInfo?.product?.current_stock ??
    "0";
  return (
    <tr>
      <td>{props.listInfo.code}</td>
      <td>
        {props.listInfo.name ? props.listInfo.name : props.listInfo.product}
      </td>
      <td>
        {stockValue}
      </td>
      <td>
        <input
          type="number"
          className="form-control"
          name="issue_qty"
          readOnly
          onChange={(e) => handleInputChange(e, props.listSl)}
          value={
            // props.listInfo.msg == "" ? props.listInfo.issue_qty || "0" : "0"
            props.listInfo.issue_qty || "0"
          }
        />
        {/* <span className="text-danger">{props.listInfo.current_stock < props.listInfo.issue_qty ? "Insufficient Stock . Current Stock Available = " + props.listInfo.current_stock : ""}</span> */}
        <span className="text-danger"><b>{props.listInfo.details}</b></span>
      </td>
     
      {/* <td className="text-center">
        <button
          className="btn btn-danger btn-sm"
          onClick={() => removeList(props.listSl)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </td> */}
    </tr>
  );
};

export default ReceipeDetail;
